/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Access_UnavailableInputs */

const fr_app_access_unavailable = /** @type {(inputs: App_Access_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès indisponible. Votre compte doit être actif pour utiliser BusinessFlow.`)
};

const en_app_access_unavailable = /** @type {(inputs: App_Access_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access unavailable. Your account must be active to use BusinessFlow.`)
};

/**
* | output |
* | --- |
* | "Access unavailable. Your account must be active to use BusinessFlow." |
*
* @param {App_Access_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const app_access_unavailable = /** @type {((inputs?: App_Access_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Access_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_access_unavailable(inputs)
	return fr_app_access_unavailable(inputs)
});